/**
 * Date format constants.
 *
 * A leaf module with no imports, so `utils/date` can read the formats without
 * importing `config/constants`, which itself imports `utils/date`. That cycle
 * made `dayjs` unreadable while `constants` loaded under Vite and esbuild.
 * `config/constants` re-exports these, so existing imports keep working.
 */

export const DATE_CONSTANTS = {
  DATE_FORMAT: 'YYYY-MM-DD',
  TIME_FORMAT: 'HH:mm:ss',
  DATETIME_FORMAT: 'YYYY-MM-DDTHH:mm:ss.SSSZ', // ISO 8601 format
} as const;
